import { Formik } from "formik";
import PageHeader from "components/Shared/PageHeader";
import { Container, Divider } from "@mui/material";
import AccountingCode from "./sections/accountingCode";
import Info from "./sections/info";
import Materials from "./sections/materials/materials";
import Wages from "./sections/wages";
import Costs from "./sections/costs";
import Remittance from "./sections/remittance";
import Footer from "./sections/footer";
import { useEffect, useState } from "react";
import { apiGetManufactureFormulas } from "api/manufactureFormulaApi";
import { apiGetManufactureOrder } from "api/manufactureOrderApi";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { DateToString } from "components/Reports/DateFilter";
import shortid from "shortid";
import { useParams } from "react-router-dom";
import { getInitialRows } from "./utils";
import { apiProductsList } from "api/productApi";
import { apiGetAccountingTypes } from "api/accountingTypeApi";

const init: MaterialOrderData = {
  isEdit: false,
  automaticRemmitance: false,
  materialsRows: getInitialRows(),
  tableTotalPrice: 0,
  finalPrice: 0,
  quantity: 1,
  date: DateToString(new Date(Date.now())),
  optionableType: "financial",
  costs: [],
  wages: [],
};

const ProductionOrder = () => {
  const dispatch = useAppDispatch();
  const store = useAppSelector((x: any) => x);
  const token = store?.businessReducer?.business?.token;
  const [loading, setLoading] = useState(true);
  const { id } = useParams() ?? { id: undefined };
  const [initialFormData, setInitialFormData] = useState<MaterialOrderData>(init);

  useEffect(() => {
    dispatch(apiGetManufactureFormulas({ token }));
    if (!store.productReducer.allProducts) {
      dispatch(apiProductsList({ token }));
    }
    dispatch(apiGetAccountingTypes(token, "cost"));
  }, [token]);

  useEffect(() => {
    if (id !== undefined && token !== undefined) {
      dispatch(
        //@ts-ignore
        apiGetManufactureOrder(id, token, (order: ManufactureOrder) => {
          //@ts-ignore
          try {
            setInitialFormData({
              isEdit: true,
              materialsRows: order.Production_Order_Items.map((item) => {
                return {
                  ind: shortid.generate(),
                  ProductId: item.ProductId,
                  Product: item.Product,
                  subUnit: item.Product.subUnit,
                  quantity: item.quantity,
                  unit: item.unit,
                  units: [item.Product.unit].flatMap((x) =>
                    item.Product.subUnit ? [x, item.Product.subUnit] : [x]
                  ),
                  totalPrice: item.totalPrice,
                  unitPrice: item.price,
                  warehouseId: item.WarehouseId,
                  warehouse: item.Warehouse,
                  selectedUnit: item.unit,
                  conversionRatio: item.Product.conversionRatio,
                };
              }),
              product: order.Product,
              productId: order.ProductId,
              automaticRemmitance: order.WarehouseId !== null ? true : false,
              remmitanceWarehouseId: order.WarehouseId,
              remmitanceWarehouse: order.Warehouse,
              costs: order.overHeadsArray.map((item) => {
                return {
                  ind: shortid.generate(),
                  amount: item.amount,
                  isCreditor: false,
                  type: item.type,
                  value: item.value,
                  label: "cost",
                  accountTypeId: item.accountTypeId,
                };
              }),
              wages: order.wagesArray.map((item) => {
                return {
                  ind: shortid.generate(),
                  amount: item.amount,
                  isCreditor: false,
                  type: item.type,
                  value: item.value,
                  label: "wage",
                  accountTypeId: item.accountTypeId,
                };
              }),
              formulaId: order.ProductionFormulaId,
              formula: order.Production_Formula,
              projectId: order.ProjectId,
              status: order.status,
              project: order.Project,
              branchId: order.BranchId,
              branch: order.Branch,
              date: order.date,
              finalPrice: order.price,
              optionableId: order.optionableId,
              optionableType: order.optionableType,
              optionable: order.resource,
              quantity: order.quantity,
              description: order.description,
              quantityUnit: order.unit,
              quantityUnits: [order.Product.unit].flatMap((x) =>
                order.Product.subUnit ? [x, order.Product.subUnit] : [x]
              ),
              tableTotalPrice: 0,
            });
          } catch (error) {
            setLoading(false);
          }
        })
      );
    }
    setLoading(false);
  }, [id]);

  return (
    <>
      {!loading && (
        <Formik initialValues={initialFormData} onSubmit={() => {}} enableReinitialize>
          <Container maxWidth="xl" className="relative">
            <PageHeader heading="سفارش ساخت محصول" actionSection={<></>} />
            <div className="pb-10 mb-6 bg-white rounded-md md:px-20">
              <AccountingCode />
              <Divider />
              <Info />
              <Divider className="my-10" />
              <Materials />
              <Divider className="my-10" />
              <Wages />
              <Divider className="my-10" />
              <Costs />
              <Divider className="my-10" />
              <Remittance />
            </div>
            <Footer />
          </Container>
        </Formik>
      )}
    </>
  );
};

export default ProductionOrder;
